import {
    PROJECTS_USERS_LOADED,
    PROJECTS_ROLES_LOADED,
    PROJECTS_USERS_ROLES_LOADING
} from '../store/actionTypes';

import {Dispatch} from 'redux';
import * as Api from '../../utils/api/api';
import {handleError} from "utils/errorHandle.function";
import {ApplicationError} from 'types/applicationError';
import {ProjectOption, ProjectsAction} from 'types/projects';
import {Role} from 'types/roles';
import {UserDTO} from 'types/userDTO';


export function projectsUsersLoading(value?: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_USERS_ROLES_LOADING,
        data: value
    }
}

export function usersLoaded(value: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_USERS_LOADED,
        data: value
    }
}

export function rolesLoaded(value: ProjectOption[]): ProjectsAction {
    return {
        type: PROJECTS_ROLES_LOADED,
        data: value
    }
}


export function getProjectsUsersAndRoles(companyId: string | number, approvers: number[]) {
    return function (dispatch: Dispatch<ProjectsAction>) {

        dispatch(projectsUsersLoading());

        const asPromises = approvers.map(approver => {
            return Api.getCompanyUser(approver).then((response: UserDTO): ProjectOption => {
                return {value: response.idUser, label: response.fullName};
            });
        });

        // one failed lookup must not cost the page every other approver's name, so each one settles on its own
        Promise.allSettled(asPromises).then(results => {
            const users = results
                .filter((result): result is PromiseFulfilledResult<ProjectOption> => result.status === "fulfilled")
                .map(result => result.value);
            dispatch(usersLoaded(users));

            // reported once: the lookups of one page usually fail for the same reason
            const failure = results.find((result): result is PromiseRejectedResult => result.status === "rejected");
            if (failure) {
                handleError(failure.reason as ApplicationError);
            }
        });

        Api.getRuleConfigurationRoles(companyId).then((response: Role[]) => {
            let mappedRoles: ProjectOption[] = response ? response.map(role => {
                return {value: role.roleId, label: role.name};

            }) : [];

            dispatch(rolesLoaded(mappedRoles))
        }, (error: ApplicationError) => {
            handleError(error);
        });
    }
}
